import { useCallback, useState, useEffect } from "react";
import { SiteModel } from "../models/site.model";
import { useUserContext } from "../../user/contexts/user.context";
import { SitesService } from "../../shared/services/sites.service";
import { useIonViewWillEnter } from "@ionic/react";
import { useSiteOffline } from "./use-site-offline.hook";
import { errorInterceptor } from '../../../http-client/interceptors/error.interceptor';

export const useSite = (siteId: string) => {
  const [site, setSite] = useState<SiteModel | null>(null);

  const { currentOrganization, hasUser } = useUserContext();
  const orgaCode = currentOrganization?.code;

  const fetchSite = useCallback(() => {
    if (!orgaCode) return Promise.resolve();
    return SitesService
      .getSite(orgaCode, siteId)
      .then(setSite)
      .catch(error => errorInterceptor(error.cause));
  }, [orgaCode, siteId]);

  // Charger le site dès que l'organisation est disponible
  useEffect(() => {
    if (hasUser && orgaCode) {
      fetchSite();
    }
  }, [hasUser, orgaCode, fetchSite]);

  useIonViewWillEnter(() => {
    if (orgaCode) {
      fetchSite();
    }
  });

  const [isPopoverOpened, togglePopover] = useState(false);

  const { launchDownload, downloadingState, launchSync, synchronizationState } = useSiteOffline(orgaCode || "", siteId);

  return {
    site,
    fetchSite,
    togglePopover,
    isPopoverOpened,
    launchDownload: (selectedBuildingIds: string[], downloadOutdoorAreas: boolean) =>
      launchDownload(selectedBuildingIds, downloadOutdoorAreas, async () => {
        await fetchSite();
        togglePopover(false);
      }),
    downloadingState,
    launchSync: (selectedBuildingIds?: string[], syncOutdoorAreas?: boolean) => launchSync(selectedBuildingIds, syncOutdoorAreas, async () => {
      await fetchSite();
      togglePopover(false);
    }),
    synchronizationState,
  };
};
